import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { cn } from '@/lib/utils/cn';
import { useSettingsStore } from '@/store';
import AuthSectionImage from '../shared/AuthSectionImage';
import MaintenanceBanner from '../shared/maintenance/MaintenanceBanner';
import { Footer } from '../template/Footer';
import { Navbar } from '../template/navbar/Navbar';
import PageLoader from '../template/PageLoader';

const AuthLayout = () => {
  const { settings } = useSettingsStore();

  const showMaintenanceBanner =
    settings.ui?.maintenance?.type === 'banner' &&
    settings.ui?.maintenance?.enabled;

  return (
    <div className="flex flex-auto flex-col justify-between min-h-screen w-full">
      <Navbar />
      {showMaintenanceBanner && <MaintenanceBanner />}
      <main
        className={cn(
          'flex-1 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-4 px-4 sm:px-6 md:px-8 py-4 sm:py-6 container',
          !showMaintenanceBanner && 'mt-16'
        )}
      >
        <AuthSectionImage />
        <Suspense fallback={<PageLoader />}>
          <div className="flex flex-col justify-center gap-4 md:gap-8 items-center relative">
            <div className="flex flex-col max-w-[340px] w-full space-y-6">
              <Outlet />
            </div>
          </div>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default AuthLayout;
